import { useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { queryParser } from '@applyft-web/utils';
import { setShowCookieBanner } from '../store/ui';
import landingTypesList from '../utils/landingTypes';

export const useCookieBanner = (path) => {
  const dispatch = useDispatch();
  // Read once: the back button handler navigates to the path without its query string
  const [skipCookies] = useState(
    () => queryParser(window?.location.search).skip_cookies === 'true'
  );
  const isLandingPage = landingTypesList.includes(path);

  useLayoutEffect(() => {
    dispatch(setShowCookieBanner(!skipCookies && isLandingPage));
  }, [dispatch, skipCookies, isLandingPage]);
};
